export default function About() {
  return (
    <div data-testid="about-page" className="max-w-4xl mx-auto px-4 sm:px-8 py-16 sm:py-24">
      <span className="font-mono text-xs uppercase tracking-widest text-orange-500">— About</span>
      <h1 className="font-display text-5xl sm:text-7xl uppercase mt-2 mb-8">The KPMX Story</h1>

      <div className="prose prose-invert max-w-none">
        <p className="text-xl text-zinc-300 leading-relaxed mb-6">
          KPMX has spent two decades doing one thing well — rebuilding motocross engines and
          getting old race bikes back on the track.
        </p>
        <p className="text-zinc-400 leading-relaxed mb-6">
          What started as a small garage workshop is now a trusted name for VMXDN riders,
          collectors and privateers across the UK. We rebuild two-stroke and four-stroke engines,
          restore evo classics from the ground up, and build fully custom race bikes.
        </p>
        <p className="text-zinc-400 leading-relaxed mb-10">
          Aftermarket parts fitted correctly. Bearings pressed and greased properly. New bikes
          stripped and prepped before they see a track. Every job logged, every torque figure
          double-checked. That's KPMX.
        </p>
      </div>

      <div className="grid sm:grid-cols-3 gap-6 mt-12">
        {[
          { k: "500+", v: "Engines rebuilt" },
          { k: "80+", v: "VMXDN race builds" },
          { k: "20+", v: "Years on tools" },
        ].map((s) => (
          <div key={s.v} className="border border-white/10 p-6 bg-zinc-900/40">
            <div className="font-display text-5xl text-orange-500">{s.k}</div>
            <div className="font-mono text-xs uppercase tracking-widest text-zinc-400 mt-2">{s.v}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
